<template>
  <v-main>
    <v-alert id="alert" v-model="alertState.isAlert" :type="alertState.type" closable class="row" @click:close="alertState.reset()">{{ alertState.message }}</v-alert>
    <v-overlay :model-value="showOverlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container fluid>
      <h1>請求書</h1>
      <div>
        ※最大で過去15ヶ月分の請求書が保存され、ダウンロードいただけます。（2021年4月利用分以降の請求書が対象）<br />
        ※請求書発行のない月は表示されません。
      </div>
    </v-container>
    <v-container fluid>
      <v-card name="billing">
        <v-data-table class="elevation-1" :headers="headers" :items="billingList" :hide-default-footer="true" density="compact" :sort-by="sortBy" :items-per-page="-1">
          <template #[`item.edit_address`]="props">
            <v-btn color="primary" class="ml-2" @click="editAddress(props.item.billing_id)">請求書送付先</v-btn>
          </template>
          <template #[`item.month`]="props">
            <select
              v-model="props.item.selectedMoth"
              class="my-1 use-month"
              :disabled="!props.item.month"
            >
              <option v-if="!props.item.month" value="0">請求書はありません</option>
              <option v-for="month in props.item.month" :value="month.value" v-bind:key="month.value">{{ month.title }}</option>
            </select>
          </template>
          <template #[`item.action`]="props">
            <v-btn color="primary" :disabled="!props.item.month" @click="download(props.item)"> ダウンロード </v-btn>
          </template>
          <template #bottom></template>
        </v-data-table>
      </v-card>
    </v-container>
    <BillingAddressDialog ref="dlgAddressEdit" :commit="saveAddress" />
  </v-main>
</template>

<script>
import Api from '@/constants/api';
import { useAlertStore } from '../stores/alert';
import BillingAddressDialog from '@/components/dialogs/BillingAddressDialog';

export default {
  components: {
    BillingAddressDialog,
  },
  setup() {
    const alertState = useAlertStore();
    return {
      alertState,
    };
  },
  data: () => ({
    headers: [
      { title: '契約ID', key: 'billing_id', sortable: true, filterable: false, width: '5%' },
      { title: '', key: 'edit_address', sortable: false, filterable: false, width: '5%' },
      { title: '法人名', key: 'billing_name', sortable: true, filterable: false, width: '20%' },
      { title: '部署', key: 'billing_section_name', sortable: true, filterable: false, width: '20%' },
      { title: '担当者', key: 'billing_representative_name', sortable: true, filterable: false, width: '20%' },
      { title: '利用月', key: 'month', sortable: false, filterable: false, width: '20%' },
      { title: '', key: 'action', sortable: false, filterable: false, width: '10%' },
    ],
    billingList: [],
    sortBy: [{ key: 'billing_id', order: 'asc' }],
    showOverlay: false,
    isButtonDisabled: false,
    loginUser: {
      billinggroupId: '',
      roleId: -1,
    },
  }),
  unmounted() {
    this.alertState.reset();
  },
  created: async function () {
    this.showOverlay = true;
    try {
      await this.createInvoiceList();
    } finally {
      this.showOverlay = false;
    }
  },
  methods: {
    createInvoiceList: async function () {
      const accessToken = this.$cookies.get('access_token');
      console.log('accessToken=' + accessToken);

      let sessionResponse = await this.axios.get(Api.PATH_SESSION);
      console.log(sessionResponse);
      if (sessionResponse.data.status == Api.STATUS_SUCCESS) {
        this.loginUser.billinggroupId = sessionResponse.data.session.billinggroup_id;
        this.loginUser.roleId = sessionResponse.data.session.role_id;
      } else {
        this.$cookies.remove('access_token');
        this.$router.push({ name: 'Login' });
        return;
      }

      if (!this.loginUser.billinggroupId) {
        console.log('billinggroupId is invalid.');
        return;
      }

      let billingInvoiceMonthListResponse = await this.axios.get(Api.PATH_BILLING_INVOICE_MONTH_LIST, {
        params: {
          billinggroup_id: this.loginUser.billinggroupId,
        },
      });
      console.log(billingInvoiceMonthListResponse);

      if (billingInvoiceMonthListResponse.data.status == Api.STATUS_SUCCESS) {
        this.billingList = billingInvoiceMonthListResponse.data.billing_list;
        if (this.billingList) {
          this.billingList.forEach((billing) => {
            billing.selectedMoth = '0';
            if (billing.invoice_list) {
              billing.month = billing.invoice_list.map((invoice) => {
                const date = new Date(Number(invoice.invoice_month.slice(0, 4)), Number(invoice.invoice_month.slice(4)) - 1, 1);
                if (Number(billing.selectedMoth) < Number(invoice.invoice_month)) {
                  billing.selectedMoth = invoice.invoice_month;
                }
                return {
                  title: date.getFullYear() + '年' + (date.getMonth() + 1) + '月',
                  value: invoice.invoice_month,
                };
              });
            }
          });
        }
        console.log(this.billingList);
      } else {
        throw 'API_BILLINGS failed. status=' + billingInvoiceMonthListResponse.data.status;
      }
    },
    download: async function (invoice) {
      this.isButtonDisabled = true;
      const response = await this.axios.get(Api.PATH_INVOICE, {
        responseType: 'blob',
        headers: { Accept: 'application/zip, application/pdf' },
        params: {
          billing_id: invoice.billing_id,
          invoice_month: invoice.selectedMoth,
        },
      });
      const type = response.headers['content-type'];
      const blob = new Blob([response.data], { type: type });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      const extension = type.split('/')[1];
      link.download =
        invoice.billing_id + '様__' + invoice.selectedMoth.slice(0, 4) + '年' + invoice.selectedMoth.slice(4) + '月' + '_請求書.' + extension;
      link.click();
      this.isButtonDisabled = false;
    },
    editAddress: async function (itemId) {
      this.$refs.dlgAddressEdit.open(await this.$api.billingAddress(itemId));
    },
    saveAddress: async function (values) {
      const isUpdated = await this.$api.billingAddressUpdate(values);
      if (isUpdated) {
        this.alertState.createAlert('success', `${values.billing_id}の請求書送付先情報を更新しました。`);
      } else {
        this.alertState.createAlert('error', '更新に失敗しました。');
      }
      return isUpdated;
    },
  },
};
</script>
<style scoped>
.container {
  width: 95%;
}
.v-overlay {
  align-items: center;
  justify-content: center;
}
.v-data-table :deep(th),
.v-data-table :deep(.v-data-table-footer) {
  font-size: 12px !important;
}
.v-data-table :deep(td) {
  font-size: 14px !important;
}
select.use-month {
  width: 12em;
  appearance: auto;
  border: 1px solid #000;
  padding: .3em;
}
</style>
